<template>
  <b-container fluid style="min-height: calc(100vh - 200px)" class="px-0">
      <b-row>
          <b-overlay class="col-md-5 p-0" :show="isEditing" :opacity="0.75" blur="5px" variant="transparent" >
              <template #overlay>
                <div class="text-center">
                  <i class="far fa-edit fa-3x"></i>
                </div>
              </template>
              <Tables ref="tableGrid"
                      class="col-md-12 mb-3"
                      :columns="[$lang.PCI.ReportEvaluation.DataTable.Description,
                                'Data Inicial',
                                'Data Final',
                                $lang.PCI.ReportEvaluation.DataTable.Date,
                                $lang.Common.DataTable.Actions]"
                      v-on:Load="onLoad">
                <template #headerCard-actions><i class="fas fa-copy"></i></template>
                <tr v-for="obj in this.objList" v-bind:key="obj.id">
                  <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :value="obj.descricao" />
                  <TableColumn :IsDateOnly="true" v-on:Edit="onSelect(obj)" :value="obj.dataInicial" />
                  <TableColumn :IsDateOnly="true" v-on:Edit="onSelect(obj)" :value="obj.dataFinal" />
                  <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :value="obj.dataAcaoFormatada" />
                  <TableColumn :HasPrint="true" :HasChange="false" :IsActionsButtons="true" v-on:Delete="onDelete(obj)" v-on:Print="onPrint(obj)"/>
                </tr>
              </Tables>
          </b-overlay>

          <forms class="col-md-7 mb-0 pl-0"
                 id="form"
                 :title="$lang.PCI.ReportEvaluation.Title"
                 :showClearButton="true"
                 :showSaveButton="true"
                 v-on:Clear="onClearForm"
                 v-on:Save="onSaveForm">
              <div class="form-group row">
                <div class="col-md-12 mb-3">
                  <label for="txtDescricao"><small v-if="form.descricao.required">* </small>{{$lang.PCI.ReportEvaluation.LabelDescription}}:</label>
                  <div class="flex-grow-1 pl-1 pr-0 mb-1 pb-3">
                    <b-form-input type="text"
                                name="txtDescricao"
                                ref="txtDescricao"
                                :placeholder="$lang.PCI.ReportEvaluation.PlaceholderDescription"
                                v-model="form.descricao.value"
                                :required="form.descricao.required"
                                :maxlength="form.descricao.maxlength"
                                :state="form.descricao.state" />
                  </div>
                  <div class="d-flex flex-wrap mb-3">
                    <b-form-group :label="'Data Inicial'" class="mr-3">
                      <datepicker
                        format="dd/MM/yyyy"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="false"
                        v-model="form.dataInicial.value"
                        :required="form.dataInicial.required"
                        :state="form.dataInicial.state"
                      />
                    </b-form-group>
                    <b-form-group :label="'Data Final'">
                      <datepicker
                        format="dd/MM/yyyy"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="false"
                        v-model="form.dataFinal.value"
                        :required="form.dataFinal.required"
                        :state="form.dataFinal.state"
                      />
                    </b-form-group>
                  </div>
                  <label><small v-if="form.descricao.required">* </small>{{$lang.PCI.ReportEvaluation.LabelMemberDescription}}:</label>
                  <div class="d-flex flex-row align-items-center py-1">
                    <v-select :options="memberList" v-model="selected" :getOptionLabel="member => `(${member.codigo}) - ${member.nome}`" style="width: 100%;"></v-select>
                  <!-- <b-form-select :options="memberList"
                                  v-model="selected"
                                  class="mr-2" ref="notifyList">
                    <template #first>
                      <b-form-select-option :value="null">
                        {{$lang.PCI.ReportEvaluation.PlaceholderMemberDescription}}
                      </b-form-select-option>
                    </template>
                  </b-form-select> -->
                  <i class="fa fa-plus-circle text-third p-1"
                      style="cursor: pointer; font-size: 1rem;"
                      @click="onNewMember">
                  </i>
                </div>
                <div class="card align-items-center d-flex flex-row mb-1" v-for="(val, index) in data.pdrRelatorioMediaFuncionario" :key="index">
                  <span class="col-11">{{`(${val.funcionario.codigo}) - ${val.funcionario.nome}`}}</span>
                  <div class="d-flex w-100 flex-wrap justify-content-end">
                    <i class="fa fa-trash text-danger p-1"
                      style="cursor: pointer; font-size: 1rem;"
                      @click="onRemoveMember(val)">
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </forms>
      </b-row>
  </b-container>
</template>

<script>
import PdrReportEvaluationMember from './pdrreportevaluationmember.js'
export default PdrReportEvaluationMember
</script>

<style scoped>
#form >>> div.card {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/pdrreportevaluationmember/pdrreportevaluationmember.vue